var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.24417 11.0776L6.4225 12.2559L10 8.67844L13.5775 12.2559L14.7558 11.0776L10 6.32178L5.24417 11.0776Z","fill":"white"}));
}

ChevronUp.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
